import type { FC } from 'react'
import { useTranslation } from '@/translations/i18n'
import type { SubmissionSource } from '../types'
import { sourceToBadgeStyle, sourceToLabelTKey } from '../utils'

interface SourceBadgeProps {
	source: SubmissionSource
}

export const SourceBadge: FC<SourceBadgeProps> = ({ source }) => {
	const { t } = useTranslation()
	return (
		<span
			className={`inline-flex text-wrap rounded-full border px-2 py-0.5 text-center font-medium text-xs ${sourceToBadgeStyle[source]}`}
		>
			{t(sourceToLabelTKey[source])}
		</span>
	)
}
